export enum ActionMode {
    Add = "ADD",
    Edit = "EDIT",
    Delete = "DELETE"
}